import * as React from 'react';
import Collapsible from 'react-collapsible';
import { colors } from '../../../../ui/theme';
import { ChevronDownIcon } from '../../../../../components/icons/ChevronIcon';

interface FaqPropsT {
  question: string;
  answer: React.ReactNode;
}

function FaqTrigger(props: {
  question: FaqPropsT['question'];
  arrowDirection: 'down' | 'up';
}) {
  let arrowClassName = 'rotate180';
  if (props.arrowDirection === 'down') {
    arrowClassName = arrowClassName + ' down';
  }

  return (
    <div className="flex justify-between items-center">
      <p className="ma0 pr3">{props.question}</p>
      <div>
        <ChevronDownIcon
          style={{ minWidth: '30px' }}
          className={arrowClassName}
          color={colors.gray800}
          size={30}
          strokeWidth={2}
        />
      </div>
    </div>
  );
}

export default function FaqSection({ question, answer }: FaqPropsT) {
  return (
    <Collapsible
      transitionCloseTime={250}
      transitionTime={250}
      trigger={<FaqTrigger question={question} arrowDirection="up" />}
      triggerWhenOpen={<FaqTrigger question={question} arrowDirection="down" />}
      triggerClassName="mingl-light-black pointer f4 db pv4 dim"
      triggerOpenedClassName="mingl-light-black pointer f4 db pv4 o-50"
      contentInnerClassName="pb4"
      openedClassName="mingl-light-black f5 lh-copy tj"
      className="mingl-light-black f5 lh-copy tj"
    >
      {answer}
    </Collapsible>
  );
}
